import dayjs from "dayjs";
import moment_tz from "moment-timezone";

const formatSplit = (s: any, type: any) => {
  if (s === null) {
    return null;
  }
  if (s === "") {
    return "";
  }
  if (s === 0 && type === 0) {
    return "0.00";
  }
  if (s === 0 && type !== 0) {
    return "0";
  }
  s =
    s < 0 && type === 0
      ? s.toString().replace(/^(\d*)$/, "$1.") + "."
      : s.toString().replace(/^(\d*)$/, "$1.");
  s = (s + "00").replace(/(\d*\.\d\d)\d*/, "$1");
  s = s.replace(".", ",");
  var re = /(\d)(\d{3},)/;
  while (re.test(s)) s = s.replace(re, "$1,$2");
  s = s.replace(/,(\d\d)$/, ".$1");

  if (type !== 0) {
    // 不带小数位(默认是有小数位)
    var a = s.split(".");
    if (a[1] === "00") {
      s = a[0];
    }
  }
  return s;
};
const formatPhone = (temp: any) => {
  if (temp == null) return "";
  let num = String(temp).replace(/[^\d]/g, "");
  if (!num) return "";
  if (num.length === 9 && num.slice(0, 1) === "4")
    return `${num.slice(0, 3)} ${num.slice(3, 6)} ${num.slice(6)}`;
  else if (num.length === 10 && num.slice(0, 2) === "04")
    return `${num.slice(0, 4)} ${num.slice(4, 7)} ${num.slice(7)}`;
  else return num;
};
const formatMultiNumber = (temp: any) => {
  if (temp == null) return "";
  let num = String(temp).replace(/[^\d]/g, "");
  if (!num) return "";
  if (num.length === 9)
    return `${num.slice(0, 3)} ${num.slice(3, 6)} ${num.slice(6)}`;
  else if (num.length === 10)
    if (num.slice(0, 2) === "04")
      return `${num.slice(0, 4)} ${num.slice(4, 7)} ${num.slice(7)}`;
    else return `(${num.slice(0, 2)}) ${num.slice(2, 6)}${num.slice(6)}`;
  else return num;
};
const formatPhoneParentheses = (temp: any) => {
  if (temp == null) return "";
  let num = String(temp).replace(/[^\d]/g, "");
  if (!num) return "";
  if (num.length === 9)
    return `${num.slice(0, 3)} ${num.slice(3, 6)} ${num.slice(6)}`;
  else if (num.length === 10)
    if (num.slice(0, 2) === "04")
      return `${num.slice(0, 4)} ${num.slice(4, 7)} ${num.slice(7)}`;
    else if (
      num.slice(0, 2) === "01" ||
      num.slice(0, 2) === "02" ||
      num.slice(0, 2) === "03" ||
      num.slice(0, 2) === "07" ||
      num.slice(0, 2) === "08"
    )
      return `(${num.slice(0, 2)}) ${num.slice(2, 6)} ${num.slice(6)}`;
    else return `(${num.slice(0, 2)}) ${num.slice(2, 6)} ${num.slice(6)}`;
  else return num;
};
const formatAbn = (temp: any) => {
  if (temp == null) return "";
  let num = String(temp).replace(/[^\d]/g, "");
  if (!num) return "";
  if (num.length === 9)
    return `${num.slice(0, 3)} ${num.slice(3, 6)} ${num.slice(6)}`;
  if (num.length === 11)
    return `${num.slice(0, 2)} ${num.slice(2, 5)} ${num.slice(
      5,
      8,
    )} ${num.slice(8)}`;
  else return num;
};
const formatNumber = (num: string) => {
  if (typeof num === "number") num = JSON.stringify(num);
  let temp = num
    .replace(/[^\d.]/g, "")
    .replace(/^\./g, "")
    .replace(/\.{2,}/g, "")
    .replace(".", "$#$")
    .replace(/\./g, "")
    .replace("$#$", ".")
    .replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3");
  return Number(temp);
};
const formatTimeStamp = (e: any) => {
  if (!e) return "-";
  if (typeof e === "string") e = Number(e);
  if (e < 10000000000) e = e * 1000;
  let time = dayjs(e).format("DD.MM.YYYY HH:mm");
  let hourMinute = time.split(" ")[1];
  let hour = Number(hourMinute.split(":")[0]);
  let hourFinal = hour > 12 ? hour - 12 : hour;
  let minute = hourMinute.split(":")[1];
  return `${time.split(" ")[0]}, ${hourFinal}:${minute}${
    hour > 11 ? " PM" : " AM"
  }`;
  // 16.05.2022, 7:35 PM
};
const getTodayDate = (zoneId: string) => {
  if (!zoneId) zoneId = "Europe/London";
  let time = new Date();
  let timestamp = time.getTime();
  let date = moment_tz(timestamp).tz(zoneId).format("YYYY-MM-DD");
  // console.log('date-------------------')
  // console.log(date)
  return date;
};

const timestampToDateNormal = (timestamp: number, zoneId: string) => {
  if (!zoneId) zoneId = "Europe/London";
  if (timestamp === 0) return "";
  if (typeof timestamp === "string") timestamp = Number(timestamp);
  if (timestamp < 10000000000) timestamp = timestamp * 1000;
  let date = moment_tz(timestamp).tz(zoneId).format("YYYY/MM/DD");

  return date;
};

const dateToCustomCount = (date: string, type: any) => {
  if (!date) return "";
  let Y = "";
  let M = "";
  let D = "";
  if (date.indexOf("/") !== -1) {
    Y = date.split("/")[0];
    M = date.split("/")[1];
    D = date.split("/")[2];
  } else if (date.indexOf("-") !== -1) {
    Y = date.split("-")[0];
    M = date.split("-")[1];
    D = date.split("-")[2];
  }
  let total = Number(D) + Number(M) * 100 + Number(Y) * 10000;
  return total;
};

const dateToYMD = (time: any) => {
  let timestamp = time.getTime();
  let date = moment_tz(timestamp).format("YYYY-MM-DD");
  return date;
};

const countBackToDate = (count: number) => {
  let y = parseInt(JSON.stringify(count / 10000));
  let m = parseInt(JSON.stringify((count - y * 10000) / 100));
  let finalM = m < 10 ? `0${m}` : m;
  let d = count - y * 10000 - m * 100;
  let finalD = d < 10 ? `0${d}` : d;
  return `${y}-${finalM}-${finalD}`;
};
const formatDatesToEnglish = (start: string, end: string) => {
  if (!start && !end) return "All Date";

  let startY = start.split("-")[0];
  let startM = start.split("-")[1];
  let startD = start.split("-")[2];
  let endY = end.split("-")[0];
  let endM = end.split("-")[1];
  let endD = end.split("-")[2];

  let dateObject = new Date(`${startY}/${startM}/${startD} 00:00:00`);
  let day = dateObject.getDay();
  let week = "";
  if (day === 0) {
    week = "Sun";
  } else if (day === 1) {
    week = "Mon";
  } else if (day === 2) {
    week = "Tue";
  } else if (day === 3) {
    week = "Wed";
  } else if (day === 4) {
    week = "Thu";
  } else if (day === 5) {
    week = "Fri";
  } else if (day === 6) {
    week = "Sat";
  }

  let dateObjectEnd = new Date(`${endY}/${endM}/${endD} 00:00:00`);
  let dayEnd = dateObjectEnd.getDay();
  let weekEnd = "";
  if (dayEnd === 0) {
    weekEnd = "Sun";
  } else if (dayEnd === 1) {
    weekEnd = "Mon";
  } else if (dayEnd === 2) {
    weekEnd = "Tue";
  } else if (dayEnd === 3) {
    weekEnd = "Wed";
  } else if (dayEnd === 4) {
    weekEnd = "Thu";
  } else if (dayEnd === 5) {
    weekEnd = "Fri";
  } else if (dayEnd === 6) {
    weekEnd = "Sat";
  }

  if (startM === "01") {
    startM = "Jan";
  } else if (startM === "02") {
    startM = "Feb";
  } else if (startM === "03") {
    startM = "Mar";
  } else if (startM === "04") {
    startM = "Apr";
  } else if (startM === "05") {
    startM = "May";
  } else if (startM === "06") {
    startM = "June";
  } else if (startM === "07") {
    startM = "July";
  } else if (startM === "08") {
    startM = "Aug";
  } else if (startM === "09") {
    startM = "Sep";
  } else if (startM === "10") {
    startM = "Oct";
  } else if (startM === "11") {
    startM = "Nov";
  } else if (startM === "12") {
    startM = "Dec";
  }

  if (endM === "01") {
    endM = "Jan";
  } else if (endM === "02") {
    endM = "Feb";
  } else if (endM === "03") {
    endM = "Mar";
  } else if (endM === "04") {
    endM = "Apr";
  } else if (endM === "05") {
    endM = "May";
  } else if (endM === "06") {
    endM = "June";
  } else if (endM === "07") {
    endM = "July";
  } else if (endM === "08") {
    endM = "Aug";
  } else if (endM === "09") {
    endM = "Sep";
  } else if (endM === "10") {
    endM = "Oct";
  } else if (endM === "11") {
    endM = "Nov";
  } else if (endM === "12") {
    endM = "Dec";
  }

  if (!end) return `${week}, ${startD} ${startM} ${startY}`;
  else if (startY === endY)
    return `${week}, ${startD} ${startM} - ${weekEnd}, ${endD} ${endM} ${endY}`;
  else
    return `${week}, ${startD} ${startM} ${startY} - ${weekEnd}, ${endD} ${endM} ${endY}`;
};
const formatDateWithWeek = (e: string) => {
  if (!e) return "";
  let start = e;
  if (start.indexOf("-") !== -1) {
    let arr = start.split("-");
    start = `${arr[0]}/${arr[1]}/${arr[2]}`;
  }
  let startY = start.split("/")[0];
  let startM = start.split("/")[1];
  let startMO = start.split("/")[1];
  let startD = start.split("/")[2];
  if (startM === "01") {
    startM = "Jan";
  } else if (startM === "02") {
    startM = "Feb";
  } else if (startM === "03") {
    startM = "Mar";
  } else if (startM === "04") {
    startM = "Apr";
  } else if (startM === "05") {
    startM = "May";
  } else if (startM === "06") {
    startM = "June";
  } else if (startM === "07") {
    startM = "July";
  } else if (startM === "08") {
    startM = "Aug";
  } else if (startM === "09") {
    startM = "Sep";
  } else if (startM === "10") {
    startM = "Oct";
  } else if (startM === "11") {
    startM = "Nov";
  } else if (startM === "12") {
    startM = "Dec";
  }

  let dateObject = new Date(`${startY}/${startMO}/${startD} 00:00:00`);
  let day = dateObject.getDay();
  let week = "";
  if (day === 0) {
    week = "Sun";
  } else if (day === 1) {
    week = "Mon";
  } else if (day === 2) {
    week = "Tue";
  } else if (day === 3) {
    week = "Wed";
  } else if (day === 4) {
    week = "Thu";
  } else if (day === 5) {
    week = "Fri";
  } else if (day === 6) {
    week = "Sat";
  }

  return `${week}, ${startD} ${startM} ${startY}`;
};
const calculateSpecificStringTimes = (string: string, specific: string) => {
  let len = string.split(specific).length - 1;
  return len;
};

const deepClone = (obj: any) => {
  //判断传进来的参数类型不是对象数组 或者是null时 直接返回
  if (typeof obj !== "object" || obj == null) {
    return obj;
  }
  //定义返回值result
  // 判断传进来的数据类型 是数组/对象 就给result一个数组/对象
  let result = Array.isArray(obj) ? ([] as any) : ({} as any);
  //循环遍历方便拷贝
  for (let key in obj) {
    //判读自有属性
    if (obj.hasOwnProperty(key)) {
      //函数递归实现深层拷贝
      result[key] = deepClone(obj[key]);
    }
  }
  //返回出去
  return result;
};

const count = (str: string, amOrPm: string) => {
  let hour = str.split(":")[0];
  let min = str.split(":")[1];
  return Number(hour) * 60 + Number(min);
};
// 获取某个月的总天数
const getDaysOfMonth = (year: number, month: number) => {
  var date = new Date(year, month, 0);
  var days = date.getDate();
  return days;
};
// 传入指定日期，获取第二天的日期
const getNextDay = (e: string) => {
  let year = 0;
  let month = 0;
  let dd = 0;
  if (e.indexOf("/") !== -1) {
    year = Number(e.split("/")[0]);
    month = Number(e.split("/")[1]);
    dd = Number(e.split("/")[2]);
  } else if (e.indexOf("-") !== -1) {
    year = Number(e.split("-")[0]);
    month = Number(e.split("-")[1]);
    dd = Number(e.split("-")[2]);
  }
  let lastday = getDaysOfMonth(year, month);
  let next = dd + 1;
  let result = "";
  if (next <= lastday) {
    let mm = month < 10 ? `0${month}` : month;
    let d = next < 10 ? `0${next}` : next;
    result = `${year}/${mm}/${d}`;
  } else {
    if (month < 12) {
      let m1 = month + 1;
      let m2 = m1 < 10 ? `0${m1}` : m1;
      result = `${year}/${m2}/01`;
    } else {
      result = `${year + 1}/01/01`;
    }
  }
  return result;
};
const getHourMinFormat = (start: string, end: string) => {
  let e = start;
  let y = end;
  if (start.indexOf("-") !== -1) {
    let arrStart = start.split("-");
    e = `${arrStart[0]}/${arrStart[1]}/${arrStart[2]}`;
    console.log(e);
  }
  if (end.indexOf("-") !== -1) {
    let arrEnd = end.split("-");
    y = `${arrEnd[0]}/${arrEnd[1]}/${arrEnd[2]}`;
  }
  // console.log("888888888888888888888888888888888");
  const dateStart = new Date(e);
  const dateEnd = new Date(y);
  const left = (dateEnd.getTime() - dateStart.getTime()) / 1000;
  const hour = Math.floor(left / 3600);
  const min = Math.floor((left - hour * 3600) / 60);
  // console.log(min);
  if (min === 0) return `${hour} hrs`;
  else {
    if (hour === 0) {
      return `${min} min${min === 1 ? "" : "s"}`;
      return;
    } else {
      return `${hour} hr${hour === 1 ? "" : "s"} ${min} min${
        min === 1 ? "" : "s"
      }`;
    }
  }
};
const turnTo24Hours = (string: string) => {
  let hour = string.split(":")[0];
  let min = string.split(":")[1];
  return Number(hour) < 12
    ? `${Number(hour) + 12}:${min}`
    : `${Number(hour)}:${min}`;
};
const timeStampToDate = (e: number) => {
  let date = moment_tz(e).format();
  return date.split("T")[0];
};
const dateToTimeStamp = (e: string, type: string) => {
  let timeStamp = Math.floor(moment_tz(e).valueOf() / 1000);
  return type === "start" ? timeStamp : timeStamp + 86399;
};
const fullToHalf = (e: string) => {
  let hour = e.split(":")[0];
  let min = e.split(":")[1];
  let amOrPm = "am";
  if (Number(hour) > 11) {
    amOrPm = "pm";
    hour = JSON.stringify(Number(hour) - 12);
  }
  if (hour === "00" || hour === "0") hour = "12";
  hour = hour.length < 2 ? `0${hour}` : hour;
  return `${hour}:${min} ${amOrPm}`;
};
const duobleFullToHalf = (start: string, end: string) => {
  let sHour = start.split(":")[0].split(" ")[1];
  let smin = start.split(":")[1];
  let sAmOrPm = "am";
  if (Number(sHour) > 11) {
    sAmOrPm = "pm";
    sHour = JSON.stringify(Number(sHour) - 12);
  }

  let eHour = end.split(":")[0].split(" ")[1];
  let emin = end.split(":")[1];
  let eAmOrPm = "am";
  if (Number(eHour) > 11) {
    eAmOrPm = "pm";
    eHour = JSON.stringify(Number(eHour) - 12);
  }

  sHour = sHour.length < 2 ? `0${sHour}` : sHour;
  eHour = eHour.length < 2 ? `0${eHour}` : eHour;
  return `${sHour}:${smin} ${sAmOrPm} - ${eHour}:${emin} ${eAmOrPm}`;
};
const formatMoneyActual = (s: any, type: number) => {
  if (s === null) {
    return "-";
  }
  if (s === "") {
    return "-";
  }
  if (s === 0) {
    return "$0";
  }
  s =
    s < 0 && type === 0
      ? s.toString().replace(/^(\d*)$/, "$1.") + "."
      : s.toString().replace(/^(\d*)$/, "$1.");
  if (type !== 0 && s.split(".")[1].length > 2) {
    let xiaoshu = s.split(".")[1];
    s = (s + "00").replace(/(\d*\.\d\d)\d*/, "$1");
    s = s.replace(".", ",");
    var re = /(\d)(\d{3},)/;
    while (re.test(s)) s = s.replace(re, "$1,$2");
    s = s.replace(/,(\d\d)$/, ".$1");
    s = `${s.split(".")[0]}.${xiaoshu}`;
  } else {
    s = (s + "00").replace(/(\d*\.\d\d)\d*/, "$1");
    s = s.replace(".", ",");
    var re = /(\d)(\d{3},)/;
    while (re.test(s)) s = s.replace(re, "$1,$2");
    s = s.replace(/,(\d\d)$/, ".$1");
  }
  if (s.indexOf(".") !== -1 && type === 0) {
    s = s.split(".")[0];
  }
  if (s.indexOf(".") === -1 && type === 1) s = s + ".00";
  if (s.indexOf("-") !== -1) s = `-$${s.split("-")[1]}`;
  else s = `$${s}`;
  return s;
};
const formatDateWithTime = (e: number) => {
  if (e < 10000000000) e = e * 1000;
  let original = dayjs(e).format("DD.MM.YYYY HH:mm");
  let start = original.split(" ")[0];
  let startY = start.split(".")[2];
  let startM = start.split(".")[1];
  let startD = start.split(".")[0];
  if (startM === "01") {
    startM = "Jan";
  } else if (startM === "02") {
    startM = "Feb";
  } else if (startM === "03") {
    startM = "Mar";
  } else if (startM === "04") {
    startM = "Apr";
  } else if (startM === "05") {
    startM = "May";
  } else if (startM === "06") {
    startM = "June";
  } else if (startM === "07") {
    startM = "July";
  } else if (startM === "08") {
    startM = "Aug";
  } else if (startM === "09") {
    startM = "Sep";
  } else if (startM === "10") {
    startM = "Oct";
  } else if (startM === "11") {
    startM = "Nov";
  } else if (startM === "12") {
    startM = "Dec";
  }

  let ap = original.split(" ")[1];
  let hour = ap.split(":")[0];
  let min = ap.split(":")[1];
  let amOrPm = "am";
  if (Number(hour) > 11) {
    amOrPm = "pm";
    hour = JSON.stringify(Number(hour) - 12);
  }

  return `${startD} ${startM} ${startY} ${Number(hour)}:${min} ${amOrPm}`;
};
const timestampToDate = (timestamp: any) => {
  if (!timestamp) return "";
  if (typeof timestamp === "string") timestamp = Number(timestamp);
  if (timestamp < 10000000000) timestamp = timestamp * 1000;
  let date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
  let Y = date.getFullYear() + " ";
  let M =
    date.getMonth() + 1 < 10
      ? "0" + (date.getMonth() + 1)
      : date.getMonth() + 1;
  if (typeof M === "number") M = JSON.stringify(M);
  if (M === "01") {
    M = "Jan";
  } else if (M === "02") {
    M = "Feb";
  } else if (M === "03") {
    M = "Mar";
  } else if (M === "04") {
    M = "Apr";
  } else if (M === "05") {
    M = "May ";
  } else if (M === "06") {
    M = "Jun";
  } else if (M === "07") {
    M = "Jul";
  } else if (M === "08") {
    M = "Aug";
  } else if (M === "09") {
    M = "Sep";
  } else if (M === "10") {
    M = "Oct";
  } else if (M === "11") {
    M = "Nov";
  } else if (M === "12") {
    M = "Dec";
  }
  let D = (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
  return `${M} ${D} ${Y}`;
};
const exportFile = (data: any, fileName: string, type: string) => {
  let blob = new Blob([data], {
    //type类型后端返回来的数据中会有，根据自己实际进行修改
    // 表格下载为 application/xlsx，压缩包为 application/zip等，
    type,
  });
  let filename = fileName;
  if (typeof (window as any).navigator.msSaveBlob !== "undefined") {
    (window as any).navigator.msSaveBlob(blob, filename);
  } else {
    var blobURL = window.URL.createObjectURL(blob);
    // 创建隐藏<a>标签进行下载
    var tempLink = document.createElement("a");
    tempLink.style.display = "none";
    tempLink.href = blobURL;
    console.log(tempLink);
    tempLink.setAttribute("download", `${filename}`);
    if (typeof tempLink.download === "undefined") {
      tempLink.setAttribute("target", "_blank");
    }
    document.body.appendChild(tempLink);
    tempLink.click();
    document.body.removeChild(tempLink);
    window.URL.revokeObjectURL(blobURL);
  }
};
export default {
  formatSplit,
  formatPhone,
  formatMultiNumber,
  formatNumber,
  formatTimeStamp,
  getTodayDate,
  timestampToDateNormal,
  dateToCustomCount,
  dateToYMD,
  countBackToDate,
  formatDatesToEnglish,
  formatDateWithWeek,
  calculateSpecificStringTimes,
  deepClone,
  formatAbn,
  count,
  getNextDay,
  getHourMinFormat,
  turnTo24Hours,
  timeStampToDate,
  dateToTimeStamp,
  fullToHalf,
  formatMoneyActual,
  formatPhoneParentheses,
  duobleFullToHalf,
  formatDateWithTime,
  timestampToDate,
  exportFile,
};
